import React from "react";
import _ from "lodash";
import { Link } from "react-router-dom";
import TableCell from "@material-ui/core/TableCell";
import placeholder from "lib/images/featured-image-tmp.png";
import { ACTIVE } from "constants/status";
import DealTableOptionsMenu from "components/Global/OptionsMenu/DealTable/DealTableOptionsMenu";
import numberFormatter from "utils/numberFormatter";
import moment from "moment";
import { map } from "constants/screenElements/soldDealTable";
import SoldDealTableMetricFormatter from "components/Global/Metric/SoldDealTableMetricFormatter";

const dealEditRedirect = id => `/portfolio/funds/free/deals/${id}`;
const getMetricValue = (deal, metricId, dotpath) => {
  const val = _.get(deal, dotpath, null);

  return SoldDealTableMetricFormatter[metricId](val);
};
const SoldDealViewTableColumns = () => [
  {
    id: "menu",
    isBaseColumn: true,
    dataField: null,
    layoutOrder: 99,
    numeric: false,
    Cell: ({ deal }) => (
      <TableCell className="loansList_Menu" key="menu">
        <DealTableOptionsMenu id={deal.id} dealEditRedirect={dealEditRedirect} />
      </TableCell>
    )
  },
  {
    id: "image",
    isBaseColumn: true,
    dataField: null,
    layoutOrder: -2,
    numeric: false,
    label: " ",
    Cell: ({ deal: { id, imageSmall }, linkPath }) => {
      let path = `/deals/${id}`;
      if (linkPath) {
        path = linkPath(id);
      }

      return (
        <TableCell className="loansList_TableImage">
          <Link to={path}>
            <img src={imageSmall || placeholder} alt="thumbnailImg" />
          </Link>
        </TableCell>
      );
    }
  },
  {
    id: "name",
    isBaseColumn: true,
    dataField: "name",
    layoutOrder: -1,
    numeric: false,
    label: "Deal",
    Cell: ({ deal: { name, id, statusId }, linkPath }) => {
      let path = `/deals/${id}`;
      if (linkPath) {
        path = linkPath(id);
      }

      return (
        <TableCell className="loansList_Link">
          <Link to={path}>
            {name}
          </Link>
        </TableCell>
      );
    }
  },
  {
    id: map.EXIT_DATE,
    isBaseColumn: false,
    dataField: "dealMetricsV2.actualExitDate",
    numeric: false,
    label: "Exit Date",
    Cell: data => {
      const value = getMetricValue(data.deal, map.EXIT_DATE, "dealMetricsV2.actualExitDate");

      return (<TableCell>{value}</TableCell>);
    }
  },
  {
    id: map.SALES_PRICE,
    isBaseColumn: false,
    dataField: "dealMetricsV2.salesPrice",
    numeric: false,
    label: "Sales Price",
    Cell: data => {
      const value = getMetricValue(data.deal, map.SALES_PRICE, "dealMetricsV2.salesPrice");

      return (<TableCell>{value}</TableCell>);
    }
  },
  {
    id: map.ASSET_TYPE,
    isBaseColumn: false,
    dataField: "dealMetricsV2.assetTypeName",
    numeric: false,
    label: "Asset Type",
    Cell: data => {
      const value = getMetricValue(data.deal, map.ASSET_TYPE, "dealMetricsV2.assetTypeName");

      return (<TableCell>{value}</TableCell>);
    }

  },
  {
    id: map.ASSET_CLASS,
    isBaseColumn: false,
    dataField: "dealMetricsV2.assetClassName",
    numeric: false,
    label: "Asset Class",
    Cell: data => {
      const value = getMetricValue(data.deal, map.ASSET_CLASS, "dealMetricsV2.assetClassName");

      return (<TableCell>{value}</TableCell>);
    }
  },
  {
    id: map.CITY,
    isBaseColumn: false,
    dataField: "dealMetricsV2.city",
    numeric: false,
    label: "City",
    Cell: data => {
      const value = getMetricValue(data.deal, map.CITY, "dealMetricsV2.city");

      return (<TableCell>{value}</TableCell>);
    }
  },
  {
    id: map.STATE,
    isBaseColumn: false,
    dataField: "dealMetricsV2.stateName",
    numeric: false,
    label: "State",
    Cell: data => {
      const value = getMetricValue(data.deal, map.STATE, "dealMetricsV2.stateName");

      return (<TableCell>{value}</TableCell>);
    }
  },
  {
    id: map.PREPAYMENT,
    isBaseColumn: false,
    dataField: "dealMetricsV2.prepaymentPenalty",
    numeric: false,
    label: "Actual Prepayment",
    Cell: data => {
      const value = getMetricValue(data.deal, map.PREPAYMENT, "dealMetricsV2.prepaymentPenalty");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.CASH_EQUITY,
    isBaseColumn: false,
    dataField: "dealMetricsV2.cashEquity",
    numeric: false,
    label: "Cash Equity",
    Cell: data => {
      const value = getMetricValue(data.deal, map.CASH_EQUITY, "dealMetricsV2.cashEquity");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.LOAN_BALANCE_AT_EXIT,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "Loan Balance at Exit",
    Cell: data => {
      const balanceAtExit = "--"; // NOT IMPLEMENTED YET

      return <TableCell>{balanceAtExit}</TableCell>;
    }
  },
  {
    id: map.BROKER_COMPANY,
    isBaseColumn: false,
    dataField: "deal.brokerCompany.name",
    numeric: false,
    label: "Broker Company",
    Cell: data => {
      const brokerCompany = _.get(data, "deal.brokerCompany.name", "--");

      return (<TableCell>{brokerCompany}</TableCell>);
    }
  },
  {
    id: map.MSA,
    isBaseColumn: false,
    dataField: "dealMetricsV2.msaName",
    numeric: false,
    label: "MSA",
    Cell: data => {
      const value = getMetricValue(data.deal, map.MSA, "dealMetricsV2.msaName");

      return (<TableCell>{value}</TableCell>);
    }
  },
  {
    id: map.HOLD_PERIOD_YEARS,
    isBaseColumn: false,
    dataField: "dealMetricsV2.holdPeriod",
    numeric: false,
    label: "Hold Period",
    Cell: data => {
      const value = getMetricValue(data.deal, map.HOLD_PERIOD_YEARS, "dealMetricsV2.holdPeriod");

      return (<TableCell>{value}</TableCell>);
    }
  },
  {
    id: map.EXIT_CAP,
    isBaseColumn: false,
    dataField: "dealMetricsV2.exitCap",
    numeric: false,
    label: "Exit Cap",
    Cell: data => {
      const value = getMetricValue(data.deal, map.EXIT_CAP, "dealMetricsV2.exitCap");

      return (<TableCell>{value}</TableCell>);
    }
  }

];

export default SoldDealViewTableColumns;
